<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M23.556 10.443a2.114 2.114 0 0 1 0 2.591c-1.864 2.433-6.335 7.443-11.556 7.443-5.22 0-9.692-5.01-11.556-7.443a2.112 2.112 0 0 1 0-2.591C2.308 8.01 6.78 3 12 3c5.22 0 9.692 5.01 11.556 7.443ZM12 15.483a3.745 3.745 0 1 0 0-7.49 3.745 3.745 0 0 0 0 7.49Z"/>
</svg>
